module.exports = __webpack_public_path__ + "static/media/icon-kebab.a6b23e73.svg";